import { render, staticRenderFns } from "./ReportesDetalladoPorCliente.vue?vue&type=template&id=78539d14&scoped=true"
import script from "./ReportesDetalladoPorCliente.vue?vue&type=script&lang=js"
export * from "./ReportesDetalladoPorCliente.vue?vue&type=script&lang=js"
import style0 from "./ReportesDetalladoPorCliente.vue?vue&type=style&index=0&id=78539d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78539d14",
  null
  
)

export default component.exports